import { useCallback, useState } from 'react';

const storageKey = (agendaItemId, name) => `tm-agenda:debate-card:${agendaItemId}:${name}`;

const readStored = (key, fallback) => {
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? fallback : value === 'true';
  } catch {
    return fallback;
  }
};

// Per-browser show/hide preference for a debate card section.
export default function useStoredToggle(agendaItemId, name, initial = true) {
  const key = storageKey(agendaItemId, name);
  const [state, setState] = useState(() => ({ key, value: readStored(key, initial) }));
  const value = state.key === key ? state.value : readStored(key, initial);
  const toggle = useCallback(() => {
    const next = !value;
    setState({ key, value: next });
    try {
      window.localStorage.setItem(key, String(next));
    } catch {
      // Storage may be unavailable (private mode); keep the in-memory state.
    }
  }, [key, value]);
  return [value, toggle];
}
